import { ReactNode } from "react";

type FeatureCardRootProps = {
  children: ReactNode,
  className?: string,
}

function FeatureCardRoot(props: FeatureCardRootProps) {
  return (
    <div className={`tw-bg-white dark:tw-bg-slate-700 dark:tw-text-slate-200 tw-p-7 tw-rounded-3xl tw-shadow ${props.className}`}>
      {props.children}
    </div>
  )
}


type FeatureCardHeaderProps = {
  className: string,
  children: ReactNode,
}

const Header = (props: FeatureCardHeaderProps) => {
  return <h2 className={`tw-font-semibold tw-text-lg ${props.className}`}>{props.children}</h2>
}


type FeatureCardBodyProps = {
  children: ReactNode,
}

const Body = (props: FeatureCardBodyProps) => {
  return <p className="tw-font-semibold tw-text-lg">{props.children}</p>
}

export let FeatureCard =  Object.assign(FeatureCardRoot, { Header, Body });